module.exports = __webpack_public_path__ + "media/images/icons/no_benefit-47683786e0ec47f4202ac2ead335b673.svg";